import { Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export default function NotConfiguredBanner() {
  const { t } = useTranslation('provider');

  return (
    <div
      style={{
        borderRadius: 14,
        background:
          'linear-gradient(135deg, rgba(250,140,22,0.06) 0%, rgba(250,140,22,0.16) 100%)',
        border: '1px solid rgba(250,140,22,0.28)',
        padding: '12px 14px',
        marginBottom: 12,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 11,
          background:
            'linear-gradient(135deg, rgba(250,140,22,0.16) 0%, rgba(250,140,22,0.32) 100%)',
          border: '1px solid rgba(250,140,22,0.22)',
          color: '#d46b08',
          fontSize: 15,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <WarningOutlined />
      </div>
      <div style={{ flex: 1, minWidth: 0, paddingTop: 1 }}>
        <Text
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#d46b08',
            display: 'block',
            marginBottom: 2,
          }}
        >
          {t('schedule.notConfigured.title')}
        </Text>
        <Text
          style={{
            fontSize: 12,
            color: 'var(--bl-text-muted, #6b7280)',
            display: 'block',
            lineHeight: 1.45,
          }}
        >
          {t('schedule.notConfigured.hint')}
        </Text>
      </div>
    </div>
  );
}
